import { Checkbox, ConfigProvider, Select } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import accountApis from '../../../../services/accountApis';

type ISendListMultiSelectProps = {
  value?: string[];
  onChange?: (value: string[]) => void;
};

interface ISalonType {
  shopId: string;
  shopName: string;
  phoneShop: string;
  zipCode: string;
}

const SendListMultiSelect = ({ value, onChange }: ISendListMultiSelectProps) => {
  const [listSalon, setListSalon] = useState<ISalonType[]>([]);

  const options = useMemo(() => {
    return listSalon.map((salon) => ({
      label: `${salon.shopName} - ${salon.zipCode}`,
      value: salon.shopId,
    }));
  }, [listSalon]);

  const handleChange = (newValue: string[]) => {
    onChange?.(newValue);
  };

  const handleChangeAll = () => {
    if (value?.length === options.length) {
      onChange?.([]);
    } else {
      const allOptions = options.map((option) => option.value);
      onChange?.(allOptions);
    }
  };

  const fetchOptions = async () => {
    try {
      const response = await accountApis.filterSalon(null, null, 1, 10000);
      if (response.status === 200) {
        setListSalon(response.data.data.content);
      } else {
        throw new Error();
      }
    } catch (error: any) {
      setListSalon([]);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  return (
    <div>
      <ConfigProvider
        theme={{
          token: {
            borderRadius: 5,
          },
          components: {
            Select: {
              optionSelectedBg: 'transparent',
            },
          },
        }}
      >
        <SelectStyled
          mode='multiple'
          size='large'
          placeholder='All Salon'
          style={{ width: '100%' }}
          showSearch
          optionFilterProp='label'
          onChange={handleChange}
          maxTagCount='responsive'
          options={options}
          value={value}
          dropdownRender={(menu) => {
            const isAllSelected = value?.length === options.length;
            return (
              <div>
                <SelectAllRowStyled onClick={handleChangeAll}>
                  <CheckboxContentStyled>
                    <Checkbox checked={isAllSelected} />
                    <CheckboxLabelStyled className={isAllSelected ? 'selected' : ''}>All Salon</CheckboxLabelStyled>
                  </CheckboxContentStyled>
                </SelectAllRowStyled>
                {menu}
              </div>
            );
          }}
          optionRender={(option) => {
            const isSelected = value?.includes(option.value as string);
            return (
              <CheckboxContentStyled key={option.value}>
                <Checkbox checked={isSelected} />
                <CheckboxLabelStyled className={isSelected ? 'selected' : ''}>{option?.label}</CheckboxLabelStyled>
              </CheckboxContentStyled>
            );
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default SendListMultiSelect;

const SelectAllRowStyled = styled.div`
  padding: 5px 12px;

  &.selected {
    background-color: #e6f4ff;
  }
`;

const CheckboxContentStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxLabelStyled = styled.span`
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: #1d2129;
  text-overflow: ellipsis;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &.selected {
    color: #008bff;
  }
`;

const SelectStyled = styled(Select)`
  border-radius: 5px;
` as typeof Select;
